import 'ol/ol.css';

export const state = {
  map: null,
  overlay: false
};

export const mutations = {};

// ---------------------- GETTERS ---------------------
export const getters = {
  getCredentials: state => id => {
    return state.services.filter(service => service.service_id === id);
  }
};

// ---------------------- SERVICES ---------------------
export const actions = {
  addMsgs({ commit }, data) {
    commit('pushMsgs', data);
  }
};
